<template>
  <div
    class="tourHotelSelectRoom_reserve-hotel"
    :class="{ selected: selected }"
  >
    <div
      class="tourHotelSelectRoom_reserve-hotelName tourHotelSelectRoom-spOnly"
    >
      {{ name }}
      {{ service }}
      {{ typeName ? '(' + typeName + ')' : '' }}
    </div>

    <plan-image :image-list="images" :has-discount="!!discount" />

    <plan-info
      :cancel-date="cancelDate"
      :discount="discount"
      :goto-amount="gotoAmount"
      :name="name"
      :refundable="refundable"
      :service="service"
      :total-value="totalValue"
      :type-name="typeName"
      :is-goto="isGoto"
      :person-count="personCount"
      :stay-day="stayDay"
      :detail-description="detailDescription"
      :detail-images="detailImages"
      :is-tour-free="isTourFree"
      :total-diff-value="totalDiffValue"
      :promotion="promotion"
      :is-dummy="isDummy"
      @plan-selected="$emit('plan-selected')"
    />
  </div>
</template>

<script>
import PlanImage from './PlanImage.vue'
import PlanInfo from './PlanInfo.vue'

export default {
  name: 'TkHotelPlanCard',
  components: { PlanImage, PlanInfo },
  props: {
    cancelDate: {
      type: String,
      default: '',
    },
    code: {
      type: String,
      required: true,
    },
    discount: {
      type: String,
      default: '',
    },
    gotoAmount: {
      type: String,
      default: '',
    },
    images: {
      type: Array,
      default: () => [],
    },
    isGoto: {
      type: Boolean,
      default: false,
    },
    name: {
      type: String,
      required: true,
    },
    personCount: {
      type: Number,
      required: true,
    },
    refundable: {
      type: Boolean,
      default: false,
    },
    service: {
      type: String,
      required: true,
    },
    stayDay: {
      type: Number,
      required: true,
    },
    totalValue: {
      type: String,
      default: '',
    },
    totalDiffValue: {
      type: [String, Number],
      default: '',
    },
    typeName: {
      type: String,
      required: true,
    },
    detailDescription: {
      type: [Array, Object],
      default: () => [],
    },
    detailImages: {
      type: Array,
      default: () => {},
    },
    isTourFree: {
      type: Boolean,
      default: false,
    },
    selected: {
      type: Boolean,
      default: false,
    },
    isDummy: {
      type: Boolean,
      default: false,
    },
    promotion: {
      type: String,
      default: '',
    },
  },
}
</script>
